<div class="nav-container">
  <nav>
    @for (tab of tabs; track tab) {
      <a (click)="selectTab(tab)" [class.active]="tab.active | async">{{ tab.title }}</a>
    }
  </nav>
</div>
<ng-content></ng-content>
